module.exports = __webpack_public_path__ + "static/media/attach.57a27915.png";